(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["td-product-info-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.currentScript ? document.currentScript.previousElementSibling : document;
    // Run for each panel on the page (handles section re-render in customizer)
    const panels = document.querySelectorAll('.td-pdp');
    panels.forEach(initPanel);

    // Shared: add the custom PDP form's current variant via AJAX, then open the cart drawer.
    function tdAddToCart(form, busyBtn) {
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      var id = idEl && idEl.value;
      var quantity = parseInt((qtyEl && qtyEl.value) || '1', 10);
      if (!id) return;
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

      // Render the cart drawer section(s) in the add request itself, so the drawer
      // morphs in ONE synchronous pass (like the theme's native add). Without this,
      // cart-items does a second async re-fetch that, on a slow/cold load, races with
      // the cart-upgrades bar (B1G1 banner/progress) being injected — leaving the
      // drawer's top section missing. Passing sections removes that race.
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        if (c.dataset && c.dataset.sectionId && sectionIds.indexOf(c.dataset.sectionId) === -1) sectionIds.push(c.dataset.sectionId);
      });
      var body = { items: [{ id: id, quantity: quantity }] };
      if (sectionIds.length) { body.sections = sectionIds.join(','); body.sections_url = window.location.pathname; }

      if (busyBtn) busyBtn.setAttribute('aria-busy', 'true');
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { alert(res.d && res.d.description ? res.d.description : 'Could not add to cart.'); return; }
          // Pass the rendered sections so cart-items morphs from the response (no re-fetch).
          // Horizon's cart drawer auto-opens on this event.
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res.d, sourceId: 'td-pdp', data: { source: 'td-pdp-atc', sections: res.d.sections } } }));
          // Morphing the cart section (it lives inside the header) can replace the
          // cart-drawer-component before its auto-open listener fires, so the drawer
          // sometimes stays closed. Open it explicitly on the freshly-rendered element.
          // Also pin to the top — it can open scrolled to the middle on async layout shift.
          var settleDrawer = function (allowOpen) {
            var cd = document.querySelector('cart-drawer-component');
            if (!cd) return;
            var dialog = cd.querySelector('dialog');
            if (allowOpen && dialog && !dialog.hasAttribute('open') && typeof cd.open === 'function') { try { cd.open(); } catch (e) {} }
            var n = cd.querySelector('.cart-drawer__content') || cd.querySelector('.cart-drawer__items') || dialog;
            if (n) n.scrollTop = 0;
          };
          [0, 120, 300].forEach(function (delay) { setTimeout(function () { settleDrawer(true); }, delay); });
          [550, 900].forEach(function (delay) { setTimeout(function () { settleDrawer(false); }, delay); });
        })
        .catch(function () { alert('Could not add to cart. Please try again.'); })
        .finally(function () { if (busyBtn) busyBtn.removeAttribute('aria-busy'); });
    }

    // Horizon's sticky add-to-cart bar isn't a product-form-component on this custom PDP,
    // so its native button adds nothing (flashes an empty drawer). Intercept it and add the
    // current variant from our panel form. Capture-phase + stopImmediatePropagation blocks
    // Horizon's broken handler.
    if (!window.__tdStickyAtcInit) {
      window.__tdStickyAtcInit = true;
      document.addEventListener('click', function (e) {
        var sb = e.target.closest && e.target.closest('.sticky-add-to-cart__button');
        if (!sb) return;
        var form = document.querySelector('.td-pdp__form');
        if (!form) return; // not our custom PDP — leave Horizon's default behaviour
        e.preventDefault();
        e.stopImmediatePropagation();
        tdAddToCart(form, sb);
      }, true);
    }

    function initPanel(panel) {
      if (panel.dataset.tdInit) return;
      panel.dataset.tdInit = '1';

      // Quantity stepper (clamp 1..10). Disable the − / + buttons at the
      // limits: the minus button at qty 1 was the #2 dead-click magnet
      // (201 dead clicks in 3 days) — a live-looking button doing nothing.
      const qty = panel.querySelector('[data-td-qty]');
      if (qty) {
        const input = qty.querySelector('[data-td-qty-input]');
        const stepBtns = qty.querySelectorAll('[data-td-qty-step]');
        function syncQtyButtons() {
          var v = parseInt(input.value, 10) || 1;
          stepBtns.forEach(function (b) {
            var step = parseInt(b.getAttribute('data-td-qty-step'), 10) || 0;
            b.disabled = (step < 0 && v <= 1) || (step > 0 && v >= 10);
          });
        }
        stepBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = parseInt(btn.getAttribute('data-td-qty-step'), 10) || 0;
            var v = parseInt(input.value, 10) || 1;
            v = Math.max(1, Math.min(10, v + step));
            input.value = v;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        input.addEventListener('change', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, Math.min(10, v));
          syncQtyButtons();
        });
        syncQtyButtons();
      }

      // Trust tiles: tap toggles the explainer note under the grid.
      const trustWrap = panel.querySelector('[data-td-pdp-trust]');
      if (trustWrap) {
        const trustNote = trustWrap.querySelector('[data-td-trust-note]');
        const trustCells = trustWrap.querySelectorAll('[data-td-trust-cell]');
        trustCells.forEach(function (cell) {
          cell.addEventListener('click', function () {
            var isOpen = cell.getAttribute('aria-expanded') === 'true';
            trustCells.forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
            if (isOpen) {
              trustNote.hidden = true;
              trustNote.textContent = '';
            } else {
              cell.setAttribute('aria-expanded', 'true');
              trustNote.textContent = cell.getAttribute('data-note') || '';
              trustNote.hidden = false;
            }
          });
        });
      }

      // B1G1 banner tap -> open the free-gift picker, same interception path
      // as Buy Now (the picker's capture-phase listener handles the click).
      const b1g1Banner = panel.querySelector('[data-td-b1g1-banner]');
      if (b1g1Banner) {
        function openPicker() {
          var buyBtn = panel.querySelector('[data-td-b1g1-buy]');
          if (buyBtn) buyBtn.click();
        }
        b1g1Banner.addEventListener('click', openPicker);
        b1g1Banner.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker(); }
        });
      }

      // Social-proof taps -> smooth-scroll to the Judge.me reviews band.
      // New dead-click magnets (Clarity audit 19-22 Jul): the star-rating
      // cluster (only "N reviews" was linked; the stars + number weren't) and
      // the rotating momentum ticker. Both are social proof — shoppers tap them
      // expecting to reach the reviews. Turn those dead taps into a scroll.
      var reviewSeekers = panel.querySelectorAll('[data-td-scroll-reviews]');
      if (reviewSeekers.length) {
        var goReviews = function (e) {
          var target = document.getElementById('judgeme-reviews') || document.querySelector('[data-td-reviews]');
          if (!target) return; // reviews not on this page — keep any native anchor behaviour
          if (e) e.preventDefault();
          // scrollIntoView self-corrects for whichever element actually scrolls
          // (window or a wrapper) and honours scroll-margin-top for the sticky
          // marquee offset — more robust than a manual window.scrollTo.
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        reviewSeekers.forEach(function (el) {
          el.addEventListener('click', goReviews);
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') goReviews(e);
          });
        });
      }

      // Add to Cart -> AJAX add + open the cart drawer (instead of a full-page jump to /cart).
      // Buy It Now (name="checkout") -> AJAX add + click the shared native cart-checkout
      // trigger ([data-td-native-checkout], rendered by td-b1g1-picker), which Razorpay
      // Magic Checkout intercepts to open its overlay in ONE step. A native /cart/add
      // submit would instead land on the /cart page (Magic only hooks cart checkout
      // clicks), forcing a second tap. Falls back to /checkout if the trigger is absent.
      var form = panel.querySelector('.td-pdp__form');
      if (form) {
        form.addEventListener('submit', function (e) {
          var submitter = e.submitter;
          if (submitter && submitter.name === 'checkout') {
            e.preventDefault();
            submitter.setAttribute('aria-busy', 'true');
            var idEl = form.querySelector('[name="id"]');
            var qtyEl = form.querySelector('[name="quantity"]');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: idEl && idEl.value, quantity: parseInt((qtyEl && qtyEl.value) || '1', 10) }] })
            }).then(function () {
              var nativeBtn = document.querySelector('[data-td-native-checkout]');
              if (nativeBtn) { try { nativeBtn.click(); } catch (err) { window.location.href = '/checkout'; } }
              else { window.location.href = '/checkout'; }
              submitter.removeAttribute('aria-busy');
            }).catch(function () {
              submitter.removeAttribute('aria-busy');
              alert('Could not start checkout. Please try again.');
            });
            return;
          }
          e.preventDefault();
          tdAddToCart(form, form.querySelector('.td-pdp__atc'));
        });
      }

      // Share button — native share sheet, fallback copy to clipboard
      var share = panel.querySelector('[data-td-share]');
      if (share) {
        share.addEventListener('click', function () {
          var url = location.href;
          var title = document.title;
          if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(function () {});
          } else if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              share.setAttribute('data-copied', '1');
              setTimeout(function () { share.removeAttribute('data-copied'); }, 1600);
            });
          }
        });
      }

      // Wishlist — try the XB Wishlist app's add API if present; otherwise toggle locally
      var wishBtn = panel.querySelector('[data-td-wishlist]');
      if (wishBtn) {
        wishBtn.addEventListener('click', function () {
          var pid = wishBtn.getAttribute('data-product-id');
          if (window.xbWishlist && typeof window.xbWishlist.add === 'function') {
            try { window.xbWishlist.add(pid); } catch (e) {}
          }
          wishBtn.toggleAttribute('data-active');
        });
      }

    }
  })();
  } catch(e) { console.error(e); }
})();

})();
